import React, { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import Card from "../../components/Card/Card";
import useGet from "../../hooks/useGet";
import UserForm from "./UserForm";

const UpdateUserPage = ({ match }) => {
  //const { username } = props.match.params.username;
  // const { data } = useGet(`/users/111111111`);

  const params = useParams();

  return (
    <Card title="Editar Utilizador">
      <UserForm
        mode={"UPDATE"}
        url={"/users"}
        successMessage={"Conta actualizada com sucesso"}
        onSuccessNavigateTo={"../utilizadores"}
        username={params.username}
      />
    </Card>
  );
};
export default UpdateUserPage;
